export enum AssetTransactionType {
Acquisition,
Improvement,
Sale,
Destruction,
Transfer,
Trading,
Settlement,
Adjustment,
Depreciation,
}
